import React, { PropsWithChildren } from 'react'
import FlexWrapContainer from './FlexWrapContainer'
import GridContainer from './GridContainer'

type TechTilesContainerProps = {
  dense: boolean
}

const TechTilesContainer = ({ children, dense }: PropsWithChildren<TechTilesContainerProps>) => {
  return dense ? <FlexWrapContainer>{children}</FlexWrapContainer> : <GridContainer>{children}</GridContainer>
}

export default TechTilesContainer
